



































































































































import { setStaffVisibleApi } from "@/api/staff";
import { teacherList, modifysort, teacherListData } from "@/api/teacherManage";
import { Component, Prop, Vue } from "vue-property-decorator";
import { PageModule } from "@/store/module/page";
import sortEditor from "../sortEditor.vue";
@Component({
  name: "teacherManage",
  components: {
    sortEditor,
  },
})
export default class extends Vue {
  tableData = [];
  activeName = "teacher";
  showDetails = false;
  showDetailsId = "";
  // jobList = [
  //   { value: "在职", key: 1 },
  //   { value: "离职", key: 2 },
  // ];
  searchInfo = {
    on_job: 1,
  };
  weekArr: string[] = [
    "星期日",
    "星期一",
    "星期二",
    "星期三",
    "星期四",
    "星期五",
    "星期六",
  ];
  searTypeenter = "";
  pageSize = 10;
  pageSizeArray = [5, 10, 30, 50, 100];
  total = 0;
  page = 1;
  sortNumber = "";
  inputbtn = true;
  created() {
    const _t = this;
    const pageData = PageModule.pageInfo.teacherMange;
    if (pageData.page) {
      _t.page = pageData.page;
    }
    this.getList(
      {
        page: _t.page,
        page_size: _t.pageSize,
      },
      () => {}
    );
    const cache = PageModule.pageInfo.teacherDetails;
    if (cache.tab) {
      PageModule.SET_PAGE_INFO({
        name: "teacherDetails",
        key: "tab",
        value: "",
      });
    }
  }
  clickDetail(e: { teacher_id: number; org_id: number }) {
    const _t = this as any;
    _t.$router.push({
      name: "teacherDetails",
      query: { id: e.teacher_id, org_id: e.org_id },
    });
  }
  getList(data: teacherListData, cb?: Function) {
    const _t = this as any;
    if (_t.searchInfo.key_word != "") {
      data.key_word = _t.searchInfo.key_word;
    }
    if (_t.searchInfo.on_job > 0) {
      data.on_job = _t.searchInfo.on_job;
    }
    teacherList(data).then((res: any) => {
      if (res.error_code == 0) {
        if (res.data.list != null) {
          res.data.list.map((item: any) => {
            item.sortBtn = false;
            item.is_show = item.is_show === 1;
          });
        }
        _t.tableData = res.data.list;
        _t.total = res.data.total;
        _t.page = res.data.page;
        if (cb) {
          cb();
        }
      }
    });
  }
  handlePagerChange(e: number) {
    PageModule.SET_PAGE_INFO({
      name: "teacherMange",
      key: "page",
      value: e,
    });
    this.getList(
      {
        page: e,
        page_size: this.pageSize,
      },
      () => {}
    );
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList(
      {
        page: 1,
        page_size: e,
      },
      () => {}
    );
  }
  handleSearch() {
    const _t = this as any;
    _t.getList(
      {
        page: 1,
        page_size: _t.pageSize,
      },
      () => {}
    );
  }
  setStaffVisible(e: any) {
    const _t = this as any;
    const is_show = e.is_show ? 1 : 2;
    setStaffVisibleApi({ staff_id: e.teacher_id, is_show: is_show })
      .then((res: any) => {
        if (res.error_code == 0) {
          _t.$message({
            type: "success",
            message: "修改成功!",
          });
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      })
      .catch(() => {
        this.getList({
          page: this.page,
          page_size: this.pageSize,
        });
      });
  }
}
